import { Checkbox as HeadlessCheckbox } from '@headlessui/react'
import { motion, AnimatePresence } from 'framer-motion'
import { Check } from 'react-feather'

interface CheckboxProps {
  id?: string
  name?: string
  checked: boolean
  onChange?: (checked: boolean) => void
  value?: string
}

export default function Checkbox({
  id,
  name,
  checked,
  onChange,
  value,
}: CheckboxProps) {
  const handleChange = (newChecked: boolean) => {
    onChange?.(newChecked)
  }

  return (
    <HeadlessCheckbox
      id={id}
      name={name}
      value={value}
      checked={checked}
      onChange={handleChange}
      className={`group relative flex items-center justify-center size-6 rounded-[4px] border-2 border-solid transition-colors ${
        checked
          ? 'bg-themed-blue-500 border-base-blue-500'
          : 'bg-themed-blue-100 border-base-blue-500'
      }`}
    >
      <AnimatePresence>
        {checked && (
          <motion.div
            key="check-container"
            initial={{ scale: 1 }}
            animate={{ scale: [0, 1] }}
            transition={{ duration: 0.2, ease: [0.4, 0, 0.23, 1] }}
            className="absolute inset-0 flex items-center justify-center"
          >
            <Check
              className={`size-4 stroke-white opacity-0 ${
                checked ? 'opacity-100' : 'opacity-0'
              } `}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </HeadlessCheckbox>
  )
}
